import React from 'react';
import { lazyGettext } from '@eb/lazy-gettext';
import { ACCOUNT_SETTINGS_URL } from '../../constants/main';

import { Lock } from '@eb/eds-iconography';

export default {
    breadcrumbs: {
        crumbs: [
            {
                path: ACCOUNT_SETTINGS_URL,
                label: lazyGettext('Account Settings'),
            },
            {
                path: '#',
                label: lazyGettext('Change Package'),
            },
        ],
    },
    iconHero: {
        heading: lazyGettext(
            'You do not have permissions to change your account package. Contact your account owner to change your package.',
        ),
        iconType: <Lock />,
        dataAutomation: 'change-plan-access-text',
    },
};
